import { Button, Flex } from "antd";

import ExaminerTable from "./ExaminerTable";
import { useNavigate } from "react-router-dom";

export default function Exam() {
  const navigate = useNavigate();

  return (
    <>
      <Flex gap="large" wrap="wrap">
        <Button onClick={() => navigate("submissions")}>
          View Submissions
        </Button>
      </Flex>
      <ExaminerTable />
    </>
  );
}
